<script>
import HeaderLight from "./light/mobile";
import Divider from "@/components/atoms/divider";
import SearchBar from "@/components/molecules/search-bar";
import ButtonNavigation from "@/components/molecules/button-navigation";
import LinkTo from "@/components/atoms/link-to";
import HeaderMenuPopin from "@/components/organisms/header/menu-popin";
import Cart from "@/components/organisms/header/cart/mobile";
import ConnexionRequired from "@/containers/connexion/connexion-required";
import EncartPanier from "@/containers/encart-panier";
import Popin from "@/components/molecules/popin";
import HtmlParser from "@/components/organisms/cms-container/html-parser";
import AutoSuggestPopin from "@/components/organisms/auto-suggest/auto-suggest-popin";
import LazyImage from "@/components/atoms/lazy-image";
import PopinViderPanier from "@/components/organisms/popins-compte/popin-vider-panier";
import ButtonIcon from "@/components/molecules/button-icon";
import { headerEmits, headerProps, useHeader } from "./mixin";

import coraLogo from "@/assets/images/cora-logo-cercle.svg";

export default {
  name: "HeaderMobile",
  components: {
    Cart,
    LinkTo,
    SearchBar,
    ButtonNavigation,
    Divider,
    HeaderMenuPopin,
    ConnexionRequired,
    EncartPanier,
    Popin,
    HtmlParser,
    AutoSuggestPopin,
    HeaderLight,
    LazyImage,
    PopinViderPanier,
    ButtonIcon
  },
  props: {
    value: { type: String, default: "" },
    webAlias: { type: String, default: "" },
    showMenuPopin: {
      type: Boolean,
      required: false,
      default: false
    },
    coinDesMarquesIds: {
      type: Array,
      required: false,
      default: () => []
    },
    showIdeesRepas: {
      type: Boolean,
      required: false,
      default: true
    },
    ...headerProps()
  },
  // provoque un bug lié au HeaderLight
  // emits: [
  //   "askAuth",
  //   "closePanel",
  //   "openOrcloseStoreLocator",
  //   "setEncartPanierVisible",
  //   "hideMenu",
  //   ...headerEmits()
  // ],
  watch: {
    showMenuPopin(newVal) {
      if (newVal) {
        this.showMenu();
      }
    }
  },
  methods: {
    showMenu() {
      if (this.$refs.menuPopin) {
        this.$refs.menuPopin.show();
      }
    },
    hideMenu() {
      if (this.$refs.menuPopin) {
        this.$refs.menuPopin.hide();
      }
    },
    askAuth() {
      this.$emit("askAuth");
    },
    showAutosuggestPopin() {
      if (this.$refs.autosuggestPopin) {
        this.$refs.autosuggestPopin.show();
      }
    }
  },
  setup(props, context) {
    const header = ref(null);
    const popinEncartPanier = ref(null);
    const confirmClear = ref(null);

    const {
      isSticky,
      typePanierToDelete,
      isHomePage,
      mobileHeaderMerchHtmlContent,
      showPopinViderPanier,
      mounted,
      beforeUnmount
    } = useHeader(props, context, header, popinEncartPanier, confirmClear);

    onBeforeUnmount(beforeUnmount);

    onMounted(mounted);

    return {
      header,
      popinEncartPanier,
      confirmClear,
      isSticky,
      typePanierToDelete,
      isHomePage,
      mobileHeaderMerchHtmlContent,
      showPopinViderPanier,
      coraLogo
    };
  }
};
</script>
<template>
  <header
    ref="header"
    class="c-header-mobile Mob_Header"
    role="banner"
  >
    <div
      class="c-header-mobile__top"
      @click="$emit('closePanel')"
    >
      <ButtonNavigation
        icon-name="hamburger"
        icon-size="md"
        icon-color="primary"
        class="c-header-mobile__button-nav c-header-mobile__button-nav--menu"
        @click="showMenu()"
      >
        <template #button-content>
          <span class="u-color-primary u-font-12 u-font-500 u-none u-block@sm">
            Menu
          </span>

          <span class="u-color-primary u-font-16 u-font-500 u-none@sm u-ml-xs">
            Nos rayons
          </span>
        </template>
      </ButtonNavigation>

      <Divider
        vertical
        class="c-header-mobile__divider"
      />
      <div class="c-header-mobile__logo-container">
        <LinkTo
          to="/"
          class="u-mr-sm"
        >
          <LazyImage
            :src="coraLogo"
            alt="Logo Cora"
            width="43"
            height="36"
          />
          <h1
            v-if="isHomePage"
            class="u-sr-only"
          >
            CORA Magasins • Drive • Livraison • Points de retrait
          </h1>
        </LinkTo>

        <span
          v-if="!isNational && shopName"
          class="u-color-grey-1 u-mt-xxs u-font-12"
        >
          {{ shopName }}
        </span>
        <ButtonIcon
          v-else
          icon-name="arrow-right"
          link
          icon-position="right"
          icon-size="xs"
          icon-color-hover="primary-light"
          no-underline
          variant="text"
          @click="$emit('openOrcloseStoreLocator')"
        >
          <span class="u-font-12">Choisir un magasin</span>
        </ButtonIcon>
      </div>
      <Divider
        vertical
        class="c-header-mobile__divider"
      />
      <Cart
        :total="montantTotalTTC"
        :is-loading="isPanierLoading"
        class="u-ml-sm"
        @click="$emit('setEncartPanierVisible', true)"
      />
      <Popin
        ref="popinEncartPanier"
        size="lg"
        side-bar
        side-bar-offset="lg"
        :visible="encartPanierVisible"
        aria-label="Panier"
        close-on-route-change
        @hidden="$emit('setEncartPanierVisible', false)"
      >
        <EncartPanier
          ref="encartPanier"
          @showPopinViderPanier="showPopinViderPanier"
        />
      </Popin>
      <PopinViderPanier
        ref="confirmClear"
        :type-panier="typePanierToDelete"
        @validate="$refs.encartPanier.notifyAndClear(typePanierToDelete)"
      />
    </div>

    <div class="c-header-mobile__bottom">
      <ClientOnly>
        <AutoSuggestPopin
          ref="autosuggestPopin"
          close-on-route-change
        />
      </ClientOnly>
      <div class="c-header-mobile__bottom-wrapper">
        <SearchBar
          class="c-header-mobile__search-bar"
          toggle-reset-search
          @focus="showAutosuggestPopin()"
        />
      </div>
    </div>

    <HeaderMenuPopin
      ref="menuPopin"
      :shop-id="shopId"
      :shop-name="shopName"
      :shop-page-link="shopPageLink"
      :shopfirst-slot-available="shopfirstSlotAvailable"
      :is-national="isNational"
      :is-home-page="isHomePage"
      :customer="customer"
      :web-alias="webAlias"
      :coin-des-marques-ids="coinDesMarquesIds"
      :show-idees-repas="showIdeesRepas"
      @openOrcloseStoreLocator="$emit('openOrcloseStoreLocator')"
      @hideMenu="$emit('hideMenu')"
    />
    <ClientOnly>
      <HtmlParser
        v-if="mobileHeaderMerchHtmlContent"
        context="toutes les pages"
        :promo-printing="true"
        :push-data="mobileHeaderMerchHtmlContent"
      />
    </ClientOnly>
    <ConnexionRequired />
    <ClientOnly>
      <transition name="header-sticky">
        <HeaderLight
          v-if="isSticky"
          v-bind="{ ...$props, ...extractListenersFromAttrs($attrs) }"
          @hideMenu="hideMenu()"
          @showMenu="showMenu()"
          @showAutosuggest="showAutosuggestPopin()"
        />
      </transition>
    </ClientOnly>
  </header>
</template>

<style lang="scss" scoped>
@import "@/assets/styles/components/header-mobile.scss";
</style>
